module.exports = __webpack_public_path__ + "static/media/css3.0d906639.png";